import {
    MOBILE_AUTH_SESSION_KEYS,
    hasFreshMobileAuthSession,
    hasLegacyMobileAuthSessionWithoutTimestamp,
} from './mobileAuthSession';

export interface MobileAuthContext {
    isMobileFlow: boolean;
    appRedirectUri: string | null;
    appType: string;
}

const inferAppTypeFromRedirectUri = (mobileRedirectUri: string | null): string | null => {
    if (!mobileRedirectUri) {
        return null;
    }

    if (mobileRedirectUri.startsWith('resq-facility://')) {
        return 'facility';
    }

    if (mobileRedirectUri.startsWith('resq-partner://')) {
        return 'vendor';
    }

    return null;
};

export const getMobileAuthContext = (searchParams: URLSearchParams): MobileAuthContext => {
    const hasMobileQueryMarker = searchParams.get('mobile') === 'true';
    const hasFreshMobileSession = hasFreshMobileAuthSession((key) => sessionStorage.getItem(key));
    const hasLegacyMobileSession =
        hasMobileQueryMarker &&
        hasLegacyMobileAuthSessionWithoutTimestamp((key) => sessionStorage.getItem(key));
    const isMobileFlow = hasMobileQueryMarker || hasFreshMobileSession || hasLegacyMobileSession;
    const appRedirectUriFromQuery = searchParams.get('app_redirect_uri');
    const appRedirectUri =
        appRedirectUriFromQuery ||
        (hasFreshMobileSession || hasLegacyMobileSession
            ? sessionStorage.getItem(MOBILE_AUTH_SESSION_KEYS.redirectUri)
            : null);
    const appType =
        searchParams.get('app_type') ||
        inferAppTypeFromRedirectUri(appRedirectUriFromQuery) ||
        inferAppTypeFromRedirectUri(appRedirectUri) ||
        (isMobileFlow ? sessionStorage.getItem(MOBILE_AUTH_SESSION_KEYS.appType) : null) ||
        'facility';

    return { isMobileFlow, appRedirectUri, appType };
};

export const getMobileAuthPayload = (
    context: MobileAuthContext,
): { app_redirect_uri: string; app_type: string } | null => {
    if (!context.isMobileFlow || !context.appRedirectUri) {
        return null;
    }

    return {
        app_redirect_uri: context.appRedirectUri,
        app_type: context.appType,
    };
};
